// @flow

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMount } from "react-use";

import { SelecaoCasasDecimais, SelecaoPeriodo } from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  selecionarPeriodo,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import { ID_PERIODO_MES_ESPECIFICO } from "../../../model";

export const processarPontualCarteira = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        competencia: edicaoMedida.competencia,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        periodicidade: 0,
        competencia: edicaoMedida.competencia,
        dataBase: dataBase,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

const PontualCarteira = () => {
  const dispatch = useDispatch();
  useMount(() => {
    dispatch(selecionarPeriodo([ID_PERIODO_MES_ESPECIFICO]));
  });
  const modoSeries = useSelector(isModoSeries);

  return (
    <>
      <SelecaoPeriodo exibirPeriodicidade={false} />
      {!modoSeries && <SelecaoCasasDecimais />}
    </>
  );
};

export default PontualCarteira;
